import { LencoImage } from '@/atomic-components/Image';
import { Thumbnail } from '@/services/wishlist/models/wishlist';
import { Box, Fade } from '@mui/material';
import { useEffect, useState } from 'react';

let interval:any;

function AutoplayImageSlider(props: { imageData: Thumbnail[] }) {
	const [current, setCurrent] = useState(0);
	const length = props.imageData.length;
	useEffect(() => {
		interval = setInterval(() => {
			nextSlide();
		}, 2000);
		return ()=>{
			clearInterval(interval)
		}
	});
	const nextSlide = () => {
		setCurrent(current === length - 1 ? 0 : current + 1);
	};

	return (
		<Box>
			{props?.imageData?.map((image, index) => {
				return (
					<Box
						key={index}
						className={index === current ? 'slide active' : 'slide'}
					>
						
							<Box>
							
								
								{index === current && (
									<Fade in={true} timeout={1000}>
									<Box sx={{height:'284px',overflow:'hidden',width: '100%',display:'flex',flexDirection:'column',justifyContent:'center' }}>
										<LencoImage url={image.url} aspectRatio={image.aspectRatio} lazy={true}/>
									</Box>	
									
									</Fade>
								)}
							
							</Box>
						
					</Box>
				);
			})}
		</Box>
	);
}

export default AutoplayImageSlider;
